export const CMS_SLUGS = {
  quickAccess: 'quick_access',
  news: 'news_and_articles',
  newsCategories: 'news_category',
  peopleSpotlights: 'people_spotlight',
  peopleSpotlightCategories: 'people_spotlight_category',
  policies: 'policies_and_procedures',
  policiesCategories: 'policies_categories',
  benefits: 'beneficii_page',
  resources: 'resources_page',
  resourcePageSlug: 'resource_slug_page',
  onboarding: 'on_boarding_page',
  onboardingSlug: 'on_boarding_slug_page',
  thankYou: 'thank_you_page',
  days_off_page: 'days_off_page',
  home_page: 'home_page',
  newsletters: 'newsletters_page',
  motivationalMessage: 'motivational_message',
  workingHours: 'working_hours_per_month',
  workTools: 'work_tools'
}
